import React from 'react';
import { Button } from '@tviklax/ui-components';
import styled from 'styled-components';

const ReviewActions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;

interface ReviewExtractedDataProps {
  onConfirm: () => void;
  onEdit?: () => void;
  secondaryActionLabel?: string;
}

export const ReviewExtractedData: React.FC<ReviewExtractedDataProps> = ({
  onConfirm,
  onEdit,
  secondaryActionLabel,
}) => {
  return (
    <ReviewActions>
      {onEdit && (
        <Button variant="outline" onClick={onEdit}>
          {secondaryActionLabel || 'Edit Manually'}
        </Button>
      )}
      <Button onClick={onConfirm}>
        Confirm & Create Order
      </Button>
    </ReviewActions>
  );
};
